import React from 'react'
import PropTypes from 'prop-types'
import { localize, localizeWithVars } from 'helpers/translator/localize'
import Confirm from 'views/confirm/confirm'

const MaxPresentationSizeReachedUpgradeConfirm = props => (
	<Confirm
		btTwo={localize('max_presentation_size_reached__upgrade_button_text')}
		alertMessage={localizeWithVars('max_presentation_size_reached__upgrade_text', { maxSizeOfPresentations: props.maxSizeOfPresentations })}
		actionButtonType={0}
		actionTwo={props.upgradeSelected}
		closeAction={props.closeConfirmSelected}
	/>
)

MaxPresentationSizeReachedUpgradeConfirm.propTypes = {
	upgradeSelected: PropTypes.func,
	closeConfirmSelected: PropTypes.func,
	maxSizeOfPresentations: PropTypes.string,
}

MaxPresentationSizeReachedUpgradeConfirm.defaultProps = {
	upgradeSelected: () => {},
	closeConfirmSelected: () => {},
	maxSizeOfPresentations: '',
}

export default MaxPresentationSizeReachedUpgradeConfirm
